var store = require('../internals/shared-store');

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/inspect-source.js
// module id = xTsD
// module chunks = 0